export default __webpack_public_path__ + "static/media/man.a8c8c6f4.svg";